// Translations for Arabic, English, and Urdu
export const translations = {
  ar: {
    // Hero Section
    heroTitle: 'اشترك معنا وخلّي رحلاتك دائمًا نظامية وآمنة',
    heroSubtitle: 'اشترك في تطبيق كشف الركاب وخلّيك نظامي.',
    heroDescription: 'أصدر كشف ركاب معتمد بالباركود المتحرك مع تسجيل كامل تفاصيل الرحلة وقائمة الركاب، لتفادي المخالفات الصادرة من وزارة النقل بكل سهولة وأمان.',
    downloadText: 'قم بتنزيل تطبيقنا',
    downloadAPK: 'تحميل APK',
    downloadiPhone: 'تحميل iPhone',
    downloadAppTooltip: 'تحميل التطبيق',
    
    // Features
    feature1Title: 'طرق دفع مرنة تناسبك مع الباقات المميزة للاشتراك في تطبيق كشف الركاب.',
    feature1Desc: 'يمكنك الدفع بأي وسيلة متاحة لأصحاب الباصات والحافلات: كاش، فيزا، أو تحويل بنكي، لتسهيل إدارة رحلاتك بكل راحة',
    
    feature2Title: 'اصدر رحلتك ف لحظات مع البركود المعتمد',
    feature2Desc: 'سجّل بيانات الركاب بسرعة عبر الكاميرا أو الصور أو الإدخال اليدوي، ونظّم رحلتك بدقة وسهولة بدون إضاعة وقت',
    
    feature3Title: 'مع تطبيق كشف الركاب',
    feature3Desc: 'يوفر إصدار كشف الركاب بسرعة وسهولة، مع ضمان مطابقة بيانات جميع الركاب لمواصفات وزارة النقل. حل إلكتروني آمن يساعد السائق وأصحاب المؤسسات على تنظيم الرحلات وتفادي المخالفات، لتبقى رحلتك دائمًا في أمان.',
    
    feature4Title: 'أمان وثقة في كل رحلة صادرة من تطبيق كشف الركاب',
    feature4Desc: 'كل رحلة معتمدة، كل سائق موثوق. مع نظام مراجعة الهوية والتقييم المستمر، نحرص على توفير نقل آمن ومريح لجميع الركاب. رحلتك آمنة… وسائقك موثوق.',
    
    // Footer
    footerDescription: '. تطبيق كشف ركاب إلكتروني معتمد بالباركود المتحرك وفق أنظمة وزارة النقل',
    contactButton: 'اتصل بنا',
    copyright: '2025 جميع الحقوق محفوظة لتطبيقنا للنقل',
    
    // WhatsApp Button
    whatsappAriaLabel: 'تواصل معنا عبر واتساب'
  },
  
  en: {
    // Hero Section
    heroTitle: 'Subscribe with us and keep your trips always organized and safe',
    heroSubtitle: 'Subscribe to the Passenger Manifest app and stay compliant.',
    heroDescription: 'Issue an approved passenger manifest with a dynamic barcode, complete with full trip details and passenger list, to easily avoid violations from the Ministry of Transport with ease and security.',
    downloadText: 'Download our app',
    downloadAPK: 'Download APK',
    downloadiPhone: 'Download iPhone',
    downloadAppTooltip: 'Download App',
    
    // Features
    feature1Title: 'Flexible payment methods with premium subscription packages for the Passenger Manifest app.',
    feature1Desc: 'You can pay using any available method for bus and coach owners: cash, visa, or bank transfer, to facilitate managing your trips with complete comfort',
    
    feature2Title: 'Issue your trip in moments with the approved barcode',
    feature2Desc: 'Register passenger data quickly via camera, photos, or manual entry, and organize your trip accurately and easily without wasting time',
    
    feature3Title: 'With the Passenger Manifest app',
    feature3Desc: 'Provides quick and easy issuance of passenger manifests, ensuring all passenger data matches Ministry of Transport specifications. A secure electronic solution that helps drivers and business owners organize trips and avoid violations, keeping your trip always safe.',
    
    feature4Title: 'Safety and trust in every trip issued from the Passenger Manifest app',
    feature4Desc: 'Every trip is approved, every driver is trusted. With identity verification and continuous rating system, we ensure safe and comfortable transportation for all passengers. Your trip is safe… and your driver is trusted.',
    
    // Footer
    footerDescription: '. An approved electronic passenger manifest app with dynamic barcode according to Ministry of Transport regulations',
    contactButton: 'Contact Us',
    copyright: '2025 All rights reserved for our transportation app',
    
    // WhatsApp Button
    whatsappAriaLabel: 'Contact us via WhatsApp'
  },
  
  ur: {
    // Hero Section
    heroTitle: 'ہمارے ساتھ سبسکرائب کریں اور اپنے سفر ہمیشہ منظم اور محفوظ رکھیں',
    heroSubtitle: 'پاسنجر مینی فیسٹ ایپ میں سبسکرائب کریں اور تعمیل میں رہیں۔',
    heroDescription: 'ایک منظور شدہ پاسنجر مینی فیسٹ جاری کریں جس میں متحرک بارکوڈ، مکمل سفر کی تفصیلات اور مسافروں کی فہرست شامل ہو، تاکہ آسانی اور حفاظت کے ساتھ وزارت نقل و حمل کی خلاف ورزیوں سے بچا جا سکے۔',
    downloadText: 'ہماری ایپ ڈاؤن لوڈ کریں',
    downloadAPK: 'APK ڈاؤن لوڈ کریں',
    downloadiPhone: 'iPhone ڈاؤن لوڈ کریں',
    downloadAppTooltip: 'ایپ ڈاؤن لوڈ کریں',
    
    // Features
    feature1Title: 'مسافروں کی فہرست ایپ میں سبسکرپشن کے لیے خصوصی پیکجز کے ساتھ آپ کی ضروریات کے مطابق لچکدار ادائیگی کے طریقے۔',
    feature1Desc: 'آپ بس اور کوچ مالکان کے لیے دستیاب کسی بھی ذریعے سے ادائیگی کر سکتے ہیں: نقد، ویزا، یا بینک ٹرانسفر، تاکہ آپ اپنی سفروں کی انتظامیہ آسانی اور مکمل سہولت کے ساتھ کر سکیں۔',
    
    feature2Title: 'منظور شدہ بارکوڈ کے ساتھ چند لمحوں میں اپنی سفر جاری کریں۔',
    feature2Desc: 'کیمرہ، تصاویر یا دستی اندراج کے ذریعے مسافروں کا ڈیٹا تیزی سے درج کریں، اور وقت ضائع کیے بغیر اپنی سفر کو درستگی اور آسانی کے ساتھ منظم کریں۔',
    
    feature3Title: 'مسافروں کی فہرست ایپ کے ساتھ',
    feature3Desc: 'یہ نظام مسافروں کی فہرست تیزی اور آسانی سے جاری کرنے کی سہولت فراہم کرتا ہے، اور اس بات کی ضمانت دیتا ہے کہ تمام مسافروں کا ڈیٹا وزارتِ ٹرانسپورٹ کے معیار کے مطابق ہو۔ ایک محفوظ الیکٹرانک حل جو ڈرائیورز اور اداروں کے مالکان کو سفروں کی تنظیم اور خلاف ورزیوں سے بچنے میں مدد دیتا ہے، تاکہ آپ کا سفر ہمیشہ محفوظ رہے۔',
    
    feature4Title: 'مسافروں کی فہرست ایپ سے جاری ہونے والے ہر سفر میں تحفظ اور اعتماد',
    feature4Desc: 'ہر سفر تصدیق شدہ ہے، ہر ڈرائیور قابل اعتماد ہے۔ شناخت کی تصدیق اور مسلسل جائزہ لینے کے نظام کے ساتھ، ہم تمام مسافروں کے لیے محفوظ اور آرام دہ نقل و حمل کو یقینی بناتے ہیں۔ آپ کا سفر محفوظ ہے… اور آپ کا ڈرائیور قابل اعتماد ہے۔',
    
    // Footer
    footerDescription: '. وزارت نقل و حمل کے ضوابط کے مطابق متحرک بارکوڈ کے ساتھ منظور شدہ الیکٹرانک پاسنجر مینی فیسٹ ایپ',
    contactButton: 'ہم سے رابطہ کریں',
    copyright: '2025 ہماری نقل و حمل ایپ کے لیے تمام حقوق محفوظ ہیں',
    
    // WhatsApp Button
    whatsappAriaLabel: 'واٹس ایپ کے ذریعے ہم سے رابطہ کریں'
  }
};

